import { render, staticRenderFns } from "./ReportDetail.vue?vue&type=template&id=56850ee4&scoped=true"
import script from "./ReportDetail.vue?vue&type=script&lang=js"
export * from "./ReportDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56850ee4",
  null
  
)

export default component.exports